import React from 'react'

const ErrorElement = (props) => {
    let errorMessage = props.message;
    return <div class={"error"}>Error - {errorMessage}</div>
}

export default ErrorElement;